<nb-card nbSpinnerSize="large" nbSpinnerStatus="primary" class="new-form-design modal-body project-pop-up customize-table">
  <nb-card-header >
          <!-- <mat-icon class="tableIcon">access_alarms</mat-icon> -->
          <span [ngStyle]="{'color': systemConfigColor }">  Customize Table</span>
          <span (click)="close()"
                  class="material-icons pull-right cursor-pointer mat-custom close-new-form pos-abs txt-clr mt-0"
                  [style.color]="this.systemConfigColor" style="border: 2px solid; border-radius: 50%; font-size: 16px;" nbTooltip="close" nbTooltipPlacement="top"
                  nbTooltipStatus="basic" nbTooltipTrigger="hover">
                  close
                </span>
          <!-- <img (click)="close()"  class="filter-close-icon" src="/assets/images/close-icon.svg" /> -->
  </nb-card-header>
  <nb-card-body >
     <div class="container setModelonRight" >
      <div class="row" >
        <div class="col-6 ">
            <div class="add-edit-form-title">
              <label>Fileds not shown in table</label>
            </div>
              <div *ngFor="let data of allMenuData; let i = index"  class="set_Checkbox">
                    <div *ngIf="data?.visible == false">
                      <nb-checkbox  (checkedChange)="checkExsistData($event , i)" >{{data?.lable}}</nb-checkbox>
                    </div>
              </div>
        </div>
        <div class="col-6 ">
          <div class="add-edit-form-title">
            <label>Fileds shown in table</label>
          </div>
            <div *ngFor="let data of allMenuData; let i = index"  class="set_Checkbox">
                  <div *ngIf="data?.visible == true">
                    <nb-checkbox value  (checkedChange)="checkExsistData($event , i)" >{{data?.lable}}</nb-checkbox>
                  </div>
            </div>
      </div>
      </div>
     </div>

  </nb-card-body>
  <nb-card-footer class="button_show" style=" position: relative; bottom: 6px;">
          <button (click)="close()" class="cancel outline-dynamic-color" nbButton matRipple>
              Cancel
          </button>
          <button (click)="save()" class="save filled-dynamic-color" nbButton matRipple>
              Save
          </button>
  </nb-card-footer>
</nb-card>
